(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByBoxReportController', avgByBoxReportController);

  /** @ngInject */
  function avgByBoxReportController ($scope, AvgByBoxReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByBoxReportViewModel();

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

  }
})();
